var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { Tooltip as SkapaTooltip } from '@ingka/tooltip-webc/passive.js';
import FunctionIconEnum from '../../enums/FunctionIconEnum.js';
import FunctionIconStyle from './FunctionIconStyle.js';
/**
 * Function Icon component.
 */
export default class FunctionIcon extends KompisElement {
    constructor() {
        super(...arguments);
        // Icon
        this.icon = null;
        // Label
        this.label = null;
        // If you use 24x24 use small or xsmall, if using 32x32 use medium.
        this.size = FunctionIconEnum.small;
    }
    async connectedCallback() {
        this.customElements.define('skapa-tooltip', SkapaTooltip);
        super.connectedCallback();
    }
    /**
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${FunctionIconStyle.getStyle({
            size: this.size,
            theme: this.theme,
            icon: this.icon
        })}
			</style>
			${this.getTemplate()}
		`;
    }
    /**
     * Returns icon.
     *
     * @returns Template.
     */
    getTemplate() {
        if (!this.label) {
            return html `<div class="container">${this.getIcon()}</div>`;
        }
        return html `
			<skapa-tooltip position="bottom">
				<div slot="custom-trigger" class="container">${this.getIcon()}</div>
				${this.label}
			</skapa-tooltip>
		`;
    }
    /**
     * Returns icon.
     *
     * @returns Template.
     */
    getIcon() {
        if (!this.icon) {
            return null;
        }
        const svg = document.createElement('svg-icon');
        const endOfSvgTag = this.icon.indexOf('>');
        if (this.label) {
            const roleAttribute = `role="img"`;
            const titleElement = `<title>${this.label}</title>`;
            svg.innerHTML =
                this.icon.slice(0, endOfSvgTag) +
                    roleAttribute +
                    this.icon.slice(endOfSvgTag, endOfSvgTag + 1) +
                    titleElement +
                    this.icon.slice(endOfSvgTag + 1);
        }
        else {
            svg.innerHTML =
                this.icon.slice(0, endOfSvgTag) + `aria-hidden=true` + this.icon.slice(endOfSvgTag);
        }
        return svg.firstChild;
    }
}
__decorate([
    property({ type: String })
], FunctionIcon.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], FunctionIcon.prototype, "label", void 0);
__decorate([
    property({ type: String })
], FunctionIcon.prototype, "size", void 0);
__decorate([
    property({ type: Object, required: true })
], FunctionIcon.prototype, "theme", void 0);
//# sourceMappingURL=FunctionIcon.js.map